import { Logout, Settings } from '@mui/icons-material';
import {
  CustomTheme,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  useTheme,
  Menu as MuiMenu,
  lighten,
  Tooltip,
} from '@mui/material';
import * as React from 'react';
import { IMenu } from './interfaces';
import { useAuth } from '../../../../../../context/AuthProvider';
import { useTranslation } from 'react-i18next';

export const Menu: React.FC<IMenu> = ({
  show,
  anchorEl,
  onClose,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  const { handleLogout } = useAuth();
  const { t } = useTranslation();

  const onLogoutClick = async (): Promise<void> => {
    await handleLogout();
  };

  return (
    <MuiMenu
      open={show}
      anchorEl={anchorEl}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: '230px',
            backgroundColor: 'transparent',
          },
        },
      }}
      MenuListProps={{
        sx: {
          borderRadius: '5px',
          backgroundColor: lighten(theme.portal.sidebar.background, 0.09),
          '& .MuiMenuItem-root': {
            borderRadius: '5px',
            mx: '5px',
            color: lighten(theme.portal.sidebar.textColor, 0.02),
          },
          '& .MuiMenuItem-root:hover': {
            backgroundColor: lighten(theme.portal.sidebar.background, 0.2),
            color: lighten(theme.portal.sidebar.textColor, 0.5),
            '& .MuiSvgIcon-root': {
              color: lighten(theme.portal.sidebar.textColor, 0.5),
            },
          },
          '& .MuiSvgIcon-root': {
            color: lighten(theme.portal.sidebar.textColor, 0.02),
          },
          '& .MuiListItemText-primary': {
            fontSize: 14,
            fontWeight: 'bold',
          },
        },
      }}
    >
      <Tooltip
        title={t('sidebar:bottomMenu.options.settings.hint')}
        placement="right"
        enterDelay={1500}
        arrow
      >
        <MenuItem>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            {t('sidebar:bottomMenu.options.settings.label')}
          </ListItemText>
          {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          ⌘V
        </Typography> */}
        </MenuItem>
      </Tooltip>
      <Divider />
      <Tooltip
        title={t('sidebar:bottomMenu.options.logout.hint')}
        placement="right"
        enterDelay={1500}
        arrow
      >
        <MenuItem onClick={onLogoutClick}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            {t('sidebar:bottomMenu.options.logout.label')}
          </ListItemText>
        </MenuItem>
      </Tooltip>
    </MuiMenu>
  );
};
